<template>
<div class="chapter">
<div class="inner_page">
<p class="SP" id="ack"> </p>
<p class="FMH"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample"><span class="ePub-B">ACKNOWLEDGMENTS</span></span></p>
<p class="FMTNI">I’m grateful for input and guidance from a number of people in the romance community. Special thanks go to Julie Miller and Kristin Gabriel, longtime members of the small but mighty Prairieland Romance Writers chapter, who both said (almost in unison), “Start when he walks into the bar.” Thanks also to Jen, for smoothing out a rough section. Laura Bradford has loved this book almost as long as I have; thanks for your patience and persistent efforts on my behalf. Finally, my most heartfelt gratitude to Eileen Rothschild, the kind of insightful editor every writer dreams of. You read a manuscript I thought was the best it could be, and showed me how to make it even better. Thank you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?3f1dd597